// extracted by mini-css-extract-plugin
module.exports = {"list":"SelfHostingBenefits_list__xWqEj","item":"SelfHostingBenefits_item__5j3Sj","icon":"SelfHostingBenefits_icon__5GeBj","description":"SelfHostingBenefits_description__yusy8"};